import React from "react";

import { useConfig } from "@/context/ConfigContext";
import { useTranslations } from "next-intl";

const SupportDetailCard = () => {
  const { config } = useConfig();
  const t = useTranslations();
 
  return (
    <div className="p-4 w-full ">
      <h3>{t(`supportObj.title`)}</h3>
      <div className="flex flex-col space-y-4 p-3 mt-4 mb-8 border border-slate-200 shadow-md rounded-md">
        <div className="flex flex-col space-y-1">
          <p className="text-xs font-medium text-slate-500">{t(`supportObj.phone`)}</p>
          <p className="text-sm text-slate-900">
            {config?.config.support.phone}
          </p>
        </div>
        <hr />
        <div className="flex flex-col space-y-1">
          <p className="text-xs font-medium text-slate-500">{t(`supportObj.email`)}</p>
          <p className="text-sm text-slate-900">
            {config?.config.support.email}
          </p>
        </div>
      </div>

     
    </div>
  );
};

export default SupportDetailCard;
